import { Player } from "@/components/Player/Player";
import { Transcription } from "@/components/Transcription/Transcription";
import { AutoScrollProvider } from "@/providers/AutoScrollContext/AutoScrollProvider";
import { useBaseStore } from "@/store/store";
import * as S from "./SectionTranscript.styled";

export function SectionTranscript() {
  const isExpanded = useBaseStore((state) => state.isExpanded);

  return (
    <S.Container isExpanded={isExpanded} data-test="transcript-section">
      <AutoScrollProvider>
        <Transcription />
        <Player />
      </AutoScrollProvider>
    </S.Container>
  );
}
